enum FormFields {
  Name = 'name',
  Market = 'market',
  PrimaryOrganizationId = 'primaryOrganizationId',
  Place = 'place',
  IsShowAddress = 'isShowAddress',
  City = 'city',
  County = 'county',
  ZipCode = 'zipCode',
  Street = 'street',
  State = 'state',
  IsMinimalMode = 'isMinimalMode',
}

const FormFieldsList = [
  FormFields.Name,
  FormFields.Market,
  FormFields.PrimaryOrganizationId,
  FormFields.Place,
  FormFields.IsShowAddress,
  FormFields.County,
  FormFields.State,
  FormFields.City,
  FormFields.Street,
  FormFields.ZipCode,
  FormFields.IsMinimalMode,
];

const NON_MANUAL_FIELDS = [FormFields.Name, FormFields.PrimaryOrganizationId, FormFields.Place];

export { FormFieldsList, FormFields, NON_MANUAL_FIELDS };
